import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { removeLast3759euu1xvfa3 as removeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  SEALED_getInstance19i1cdv1u9v1e as SEALED_getInstance,
  OPEN_getInstance3fojhnrvzj4l0 as OPEN_getInstance,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function encodeElement($this, desc, index) {
  var tag = $this.getTag_u4dqfb_k$(desc, index);
  pushTag($this, tag);
  return true;
}
function _get_currentTagOrNull__k1dbj4($this) {
  return lastOrNull($this.tagStack_1);
}
function pushTag($this, name) {
  $this.tagStack_1.add_utx5q5_k$(name);
}
function popTag($this) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!$this.tagStack_1.isEmpty_y1axqb_k$()) {
    tmp = $this.tagStack_1.removeAt_6niowx_k$(get_lastIndex($this.tagStack_1));
  } else {
    tmp = 'value';
  }
  return tmp;
}
function nested($this, nestedName) {
  var tmp0_elvis_lhs = _get_currentTagOrNull__k1dbj4($this);
  return $this.composeName_8y2y4d_k$(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
}
var StringDeferringEncoderClass;
function StringDeferringEncoder() {
  if (StringDeferringEncoderClass === VOID) {
    class $ {
      constructor(config, steadyHeaders) {
        steadyHeaders = steadyHeaders === VOID ? true : steadyHeaders;
        this.config_1 = config;
        this.steadyHeaders_1 = steadyHeaders;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.map_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp_0.seenStack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp_1.tagStack_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      get_serializersModule_piitvg_k$() {
        return this.config_1.serializersModule_1;
      }
      encode_rxtnhk_k$(value) {
        return toString(value);
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        var tmp0_subject = serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
        if (equals(tmp0_subject, SEALED_getInstance()) || equals(tmp0_subject, OPEN_getInstance()) || (equals(tmp0_subject, LIST_getInstance()) || equals(tmp0_subject, MAP_getInstance()))) {
          if (this.steadyHeaders_1) {
            this.encodeTaggedValue_sfcjfh_k$(popTag(this), this.config_1.deferMarker_1 + this.config_1.deferredFormat_1.encodeToString_k0apqx_k$(serializer, value));
          } else {
            serializer.serialize_5ase3y_k$(this, value);
          }
        } else if (equals(tmp0_subject, CLASS_getInstance()))
          if (this.steadyHeaders_1 && this.seenStack_1.contains_aljjnj_k$(serializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$())) {
            this.encodeTaggedValue_sfcjfh_k$(popTag(this), this.config_1.deferMarker_1 + this.config_1.deferredFormat_1.encodeToString_k0apqx_k$(serializer, value));
          } else {
            this.seenStack_1.add_utx5q5_k$(serializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
            serializer.serialize_5ase3y_k$(this, value);
            removeLast(this.seenStack_1);
          }
         else {
          serializer.serialize_5ase3y_k$(this, value);
        }
      }
      encodeTaggedValue_sfcjfh_k$(tag, value) {
        var tmp0 = this.map_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = this.encode_rxtnhk_k$(value);
        tmp0.put_4fpzoq_k$(tag, value_0);
      }
      encodeTaggedNull_qzw0n5_k$(tag) {
        var tmp0 = this.map_1;
        // Inline function 'kotlin.collections.set' call
        var value = this.config_1.nullMarker_1;
        tmp0.put_4fpzoq_k$(tag, value);
      }
      encodeTaggedEnum_56ln9q_k$(tag, enumDescriptor, ordinal) {
        var tmp0 = this.map_1;
        // Inline function 'kotlin.collections.set' call
        var value = this.encode_rxtnhk_k$(enumDescriptor.getElementName_u4sqmf_k$(ordinal));
        tmp0.put_4fpzoq_k$(tag, value);
      }
      encodeTaggedNonNullMark_qfer1t_k$() {
      }
      encodeTaggedInt_tkpbln_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedByte_5409y0_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedShort_wf2i94_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedLong_ifi8eg_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedFloat_4is9mw_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedDouble_wgtjw1_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedBoolean_hv2cld_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, value);
      }
      encodeTaggedChar_owp4mj_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, new (Char())(value));
      }
      encodeTaggedString_wkr2bh_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$(tag, startsWith(value, this.config_1.deferMarker_1) ? this.config_1.deferMarker_1 + this.config_1.deferredFormat_1.encodeToString_k0apqx_k$(serializer(StringCompanionObject_instance), value) : value);
      }
      encodeTaggedInline_obtvwh_k$(tag) {
        // Inline function 'kotlin.apply' call
        pushTag(this, tag);
        return this;
      }
      encodeInline_wxp5pu_k$(descriptor) {
        return this.encodeTaggedInline_obtvwh_k$(popTag(this));
      }
      encodeNotNullMark_415a1t_k$() {
        return this.encodeTaggedNonNullMark_qfer1t_k$();
      }
      encodeNull_ejiosz_k$() {
        return this.encodeTaggedNull_qzw0n5_k$(popTag(this));
      }
      encodeBoolean_tu2e59_k$(value) {
        return this.encodeTaggedBoolean_hv2cld_k$(popTag(this), value);
      }
      encodeByte_6txfee_k$(value) {
        return this.encodeTaggedByte_5409y0_k$(popTag(this), value);
      }
      encodeShort_gza6si_k$(value) {
        return this.encodeTaggedShort_wf2i94_k$(popTag(this), value);
      }
      encodeInt_y5zi3z_k$(value) {
        return this.encodeTaggedInt_tkpbln_k$(popTag(this), value);
      }
      encodeLong_vlw3uq_k$(value) {
        return this.encodeTaggedLong_ifi8eg_k$(popTag(this), value);
      }
      encodeFloat_b8b85a_k$(value) {
        return this.encodeTaggedFloat_4is9mw_k$(popTag(this), value);
      }
      encodeDouble_n270q9_k$(value) {
        return this.encodeTaggedDouble_wgtjw1_k$(popTag(this), value);
      }
      encodeChar_id8ngf_k$(value) {
        return this.encodeTaggedChar_owp4mj_k$(popTag(this), value);
      }
      encodeString_424b5v_k$(value) {
        return this.encodeTaggedString_wkr2bh_k$(popTag(this), value);
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return this.encodeTaggedEnum_56ln9q_k$(popTag(this), enumDescriptor, index);
      }
      beginStructure_yljocp_k$(descriptor) {
        return this;
      }
      endStructure_1xqz0n_k$(descriptor) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.tagStack_1.isEmpty_y1axqb_k$()) {
          popTag(this);
        }
      }
      encodeBooleanElement_ydht7q_k$(descriptor, index, value) {
        return this.encodeTaggedBoolean_hv2cld_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeByteElement_kft2ib_k$(descriptor, index, value) {
        return this.encodeTaggedByte_5409y0_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeShortElement_4bcdph_k$(descriptor, index, value) {
        return this.encodeTaggedShort_wf2i94_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeIntElement_krhhce_k$(descriptor, index, value) {
        return this.encodeTaggedInt_tkpbln_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeLongElement_ovnxxh_k$(descriptor, index, value) {
        return this.encodeTaggedLong_ifi8eg_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeFloatElement_oe8hn_k$(descriptor, index, value) {
        return this.encodeTaggedFloat_4is9mw_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeDoubleElement_a6rqhe_k$(descriptor, index, value) {
        return this.encodeTaggedDouble_wgtjw1_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeCharElement_5nnekk_k$(descriptor, index, value) {
        return this.encodeTaggedChar_owp4mj_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeStringElement_1n5wu2_k$(descriptor, index, value) {
        return this.encodeTaggedString_wkr2bh_k$(this.getTag_u4dqfb_k$(descriptor, index), value);
      }
      encodeInlineElement_69jjkk_k$(descriptor, index) {
        return this.encodeTaggedInline_obtvwh_k$(this.getTag_u4dqfb_k$(descriptor, index));
      }
      encodeSerializableElement_isqxcl_k$(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.encodeNullableSerializableValue_ibrab1_k$(serializer, value);
        }
      }
      getTag_u4dqfb_k$(_this__u8e3s4, index) {
        return nested(this, this.elementName_p66hrm_k$(_this__u8e3s4, index));
      }
      elementName_p66hrm_k$(descriptor, index) {
        return descriptor.getElementName_u4sqmf_k$(index);
      }
      composeName_8y2y4d_k$(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
    }
    protoOf($).beginCollection_9edss2_k$ = beginCollection;
    protoOf($).encodeNullableSerializableValue_ibrab1_k$ = encodeNullableSerializableValue;
    protoOf($).shouldEncodeElementDefault_x8eyid_k$ = shouldEncodeElementDefault;
    initMetadataForClass($, 'StringDeferringEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    StringDeferringEncoderClass = $;
  }
  return StringDeferringEncoderClass;
}
//region block: exports
export {
  StringDeferringEncoder as StringDeferringEncoder2g68f2tkdfmtv,
};
//endregion

//# sourceMappingURL=StringDeferringEncoder.mjs.map
